export default function HalamanDetailKPI() {
  return <></>;
}
